import React from "react";
import { useSelector } from "react-redux";
import { RetentionForm } from "components/RetentionForm/RetentionForm";
import { RETENTION_OUTPUTS_LABELS } from "./labels";

const { modals, buttons } = RETENTION_OUTPUTS_LABELS;

export function RetentionOutputForm({ open, onClose }) {
  const { station, year, month } = useSelector(({ retentionOutputs }) => retentionOutputs);

  return (
    <RetentionForm
      open={open}
      onClose={onClose}
      station={station}
      month={month}
      year={year}
      title={modals.newOutput}
      submitBtnText={buttons.save}
    />
  );
}
